import { render, staticRenderFns } from "./PdfOtherInfo.vue?vue&type=template&id=93d2868e&scoped=true&"
import script from "./PdfOtherInfo.vue?vue&type=script&lang=js&"
export * from "./PdfOtherInfo.vue?vue&type=script&lang=js&"
import style0 from "./PdfOtherInfo.vue?vue&type=style&index=0&id=93d2868e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d2868e",
  null
  
)

export default component.exports